<template>
  <reservation-notifications
    class="pt-life-experience-pavilion-reservation__page"
  ></reservation-notifications>
</template>

<script>
import reservationNotifications from 'cps/appointment-application/pt-life-experience-pavilion-reservation/reservation-notifications/index.vue'

export default {
  name: 'reservation-notifications__view',
  components: {
    'reservation-notifications': reservationNotifications
  }
}
</script>
